import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { v4 as uuidv4 } from 'uuid'; 
import {
  Form,
  Tab,
  Nav,
  Button,
  Dropdown,
  Row,
  Col,
  ListGroup,
  Modal,
} from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import ReactFsLightbox from "fslightbox-react";
import { TbFileUpload, TbPhoneCall } from "react-icons/tb";

//img

import user1 from "../../../assets/images/user/users.png";
import user2 from "../../../assets/images/chat/avatar/02.png";
import user3 from "../../../assets/images/chat/avatar/03.png";
import user4 from "../../../assets/images/chat/avatar/04.png";
import user5 from "../../../assets/images/chat/avatar/05.png";
import user6 from "../../../assets/images/chat/avatar/06.png";
import user7 from "../../../assets/images/chat/avatar/07.png";
import user8 from "../../../assets/images/chat/avatar/08.png";
import user9 from "../../../assets/images/chat/avatar/09.png";

import user10 from "../../../assets/images/chat/avatar/10.png";
import chatImg from "../../../assets/images/chat/05.png";

//scrollbar
import Scrollbar from "smooth-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchIgConversations,
  getIgConversationByUser,
  igautochat,
  instagramsendmessage,
} from "../../../store/instagram/instagramThunk";
import { uploadFileToCloudinary } from "../../../store/Cloudinary/CloudinaryThunk";
import EmojiPicker from "emoji-picker-react";
import { getQuickreplyAllData } from "../../../store/Quickreply/QuickreplyThunk";
import MeetModel from "./meetModel";
import { generateMeeting } from "../../../store/google/googleThunk";
import { FaVideo } from "react-icons/fa";


const Chat = () => {
  const [chats, setChats] = useState(null);
  const [Showimg, setShowimg] = useState(null);
  const inputFile = useRef(null);

  const [currentChatId, setCurrentChatId] = useState(null);
  const [senderId, setSenderId] = useState();
  const [messages, setMessages] = useState([]);
  const [instagramAccountId, setInstagramAccountId] = useState();
  const [messageNavbar, setMessageNavbar] = useState(null);
  const [imageController, setImageController] = useState({
    toggler: false,
    slide: 1,
  });
  const [searchTerm, setSearchTerm] = useState("");

  const [isSwitchOn, setIsSwitchOn] = useState();
  const [image, setImage] = useState("");
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const [showquickreply, setShowQuickReply] = useState(false);
  const [filteredQuickReplies, setFilteredQuickReplies] = useState(null);
  const [newMessage, setNewMessage] = useState("");

  const [newmessageDate, setNewMessageDate] = useState(null);
  const [humanagent, setHumanagent] = useState(null);

  const [faqs, setFaqs] = useState(null);
  const [show, setShow] = useState(false);

  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);


  const [show6, setShow6] = useState(false);
  const [generatedLink, setGeneratedLink] = useState(null);
  const handleClose6 = () => setShow6(false);

  const limit = 20;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { getQuickreplyLoding, getQuickreplyerrer, getQuickreplySuccess } =
    useSelector((state) => state.Quickreply);
  // let messageDate=null;
  const FsLightbox = ReactFsLightbox.default
    ? ReactFsLightbox.default
    : ReactFsLightbox;
  let dispatch = useDispatch();
  const sectionRef = useRef(null);
  const { conversations, loading, conversationDetails, error, message } =

    useSelector((state) => state.instagram);
  const { uploadStatus, uploadedFile, uploadError } = useSelector(
    (state) => state.cloudinary
  );
  const { generateMeetingFullfill } = useSelector((state) => state.google);
  // console.log('messageDate',messageDate)

  console.log(conversations, loading, error);
  console.log(
    conversationDetails,
    "conversationDetailsconversationDetailsconversationDetailsconversationDetailsconversationDetails"
  );
  console.log(message, "-------------message-----------");

  useEffect(() => {
    dispatch(fetchIgConversations());
    dispatch(getQuickreplyAllData());
  }, []);
  useEffect(() => {
    if (newmessageDate) {
      const messageDate = new Date(newmessageDate); // Ensure it's a valid Date object
      messageDate.setHours(messageDate.getHours() + 24); // Add 24 hours
      console.log(messageDate.toISOString(), "Processed Future Date");
      console.log(new Date().toISOString(), "Current Date");
      if (messageDate) {
        // setFutureDate(new Date(messageDate)); // Set the future date
        if (new Date() > new Date(messageDate)) {
          setHumanagent(true);
        } else {
          setHumanagent(false);
        }
        console.log(
          messageDate,
          new Date(),
        );
      }
    }
  }, [newmessageDate]);

  useEffect(() => {
    // WebSocket connection
    const ws = new WebSocket("ws://localhost:8080");

    ws.onopen = () => {
      console.log("WebSocket connection established");
    };

    ws.onmessage = async (event) => {
      try {
        console.log(event, "WebSocket message received");
        const message = JSON.parse(event.data);
        console.log(
          message,
          "messagemessagemessagemessagemessagemessagemessage"
        );
        if (message.type === "message") {
          console.log(message.attachments, "attachment WebSocket message");
          console.log(
            message?.sender === senderId,
            "message?.sender?.id  === senderIdmessage?.sender?.id  === senderId"
          );
          console.log(
            message?.recipient === senderId,
            "message?.recipient.id === senderIdmessage?.recipient.id === senderId"
          );

          console.log(
            message?.recipient,
            "message?.recipient.idmessage?.recipient.id"
          );
          console.log(senderId, "senderIdsenderId");
          setNewMessageDate(message.timestamp);
          if (message?.sender === senderId || message?.recipient === senderId) {
            if (message.text) {
              console.log(message.text, "message.text");
              await setMessages((prevMessages) => [
                ...prevMessages,
                {
                  message: message.text,
                  id: message.mid || uuidv4(),
                  from: { id: message.sender },
                  created_time: message.timestamp,
                },
              ]);
              sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
            } else if (
              message?.shares?.link != null &&
              message?.shares?.type != null
            ) {
              await setMessages((prevMessages) => [
                ...prevMessages,
                {
                  message: "",
                  id: message.mid,
                  shares: {
                    data: [
                      {
                        link: message.shares.link,
                        type: message.shares.type,
                      },
                    ],
                  },
                  from: { id: message.sender },
                  created_time: message.timestamp,
                },
              ]);
            } else if (
              message?.attachments?.video_data != null ||
              message.attachments?.image_data != null
            ) {
              if (message.attachments?.video_data) {
                await setMessages((prevMessages) => [
                  ...prevMessages,
                  {
                    message: "",
                    id: message.mid,
                    attachments: {
                      data: [{ video_data: message.attachments.video_data }],
                    },
                    from: { id: message.sender },
                    created_time: message.timestamp,
                  },
                ]);
              } else if (message.attachments?.image_data) {
                await setMessages((prevMessages) => [
                  ...prevMessages,
                  {
                    message: "",
                    id: message.mid,
                    attachments: {
                      data: [{ image_data: message.attachments.image_data }],
                    },
                    from: { id: message.sender },
                    created_time: message.timestamp,
                  },
                ]);
                console.log(messages, "Updated Messages");
              }
            }
          }
        } else if (message.type === "postback") {
          const { sender, recipient, payload, title } = message;
          if (sender === senderId || recipient === senderId) {
            if (title) {
              console.log(
                title,
                "message.textmessage.textmessage.textmessage.textmessage.text"
              );
              await setMessages((prevMessages) => [
                ...prevMessages,
                {
                  message: message ? title : "",
                  // id: message.mid,
                  from: { id: sender },
                },
              ]);
              // sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
            }
          }
        } else if (message.type === "conversationsIg") {
          setChats(
            message?.newConversation?.data || message?.AllConversation?.data
          );
        } else if (message.type === "delete_message") {
          setMessages((prevMessages) => {
            const updatedMessages = prevMessages.filter((msg) => msg.id !== message.messageId);
            return [...updatedMessages]; // Ensure state updates properly
          });

          sectionRef.current?.scrollTo(0, sectionRef.current.scrollHeight);
        } else {
          console.error(
            "Received message does not contain 'text' or 'senderId' property"
          );
        }
      } catch (error) {
        console.log("Error parsing WebSocket message:", error);
      }
    };
    // console.log(messages, "mmmmmmmmmmmmmmmmmmmmmmmmm");

    ws.onerror = (error) => {
      console.error("WebSocket error:", error);
    };
    ws.onclose = () => {
      console.warn("WebSocket connection closed");
      // Optionally, you can try reconnecting here.
    };
    //  sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);

    // Clean up the WebSocket connection on component unmount
    return () => {
      ws.close();
    };
  }, [senderId]);

  useEffect(() => {
    setFaqs(getQuickreplySuccess?.data);
  }, [getQuickreplySuccess]);

  // useEffect(() => {
  //   setChats(conversations);

  // }, [isSwitchOn,conversations]);

  useEffect(() => {
    if (!currentChatId || !senderId) {
      setChats(conversations);
      // dispatch(getIgConversationByUser(conversations[0]?.id));
      // dispatch(getIgConversationByUser({ currentChatId: conversations[0]?.id, page, limit }));
      setSenderId(conversations[0]?.participants?.data[1]?.id);
      setMessageNavbar(conversations[0]);
      setCurrentChatId(conversations[0]?.id);
      setIsSwitchOn(conversations[0]?.autochat);
    }
  }, [conversations]);

  useEffect(() => {
    setChats(conversations);
    // dispatch(getIgConversationByUser(conversations[0]?.id));
    // setSenderId(conversations[0]?.participants?.data[1]?.id);
    // setMessageNavbar(conversations[0]);
    // setCurrentChatId(conversations[0]?.id);
    // setIsSwitchOn(conversations[0]?.autochat);
  }, [isSwitchOn]);
  useEffect(() => {
    if (currentChatId) {
      setPage(1);
      setMessages([]);
      setHasMore(true);
      dispatch(getIgConversationByUser({ currentChatId, page, limit }));
      // dispatch(getIgConversationByUser(currentChatId));
    }
  }, [currentChatId]);

  useEffect(() => {
    if (conversationDetails?.data) {
      const reversedData = [...conversationDetails.data].reverse(); // Create a reversed copy
      // setMessages(reversedData); // Set messages with reversed data
      setMessages((prevMessages) => [...reversedData, ...prevMessages]);
      setNewMessageDate(reversedData[reversedData?.length - 1]?.created_time);
    }
    console.log(conversationDetails?.recipient, "---id----");
    setInstagramAccountId(conversationDetails?.recipient);
  }, [conversationDetails]);

  // useEffect(() => {
  //   Scrollbar.init(document.querySelector(".data-scrollbar"));
  // });
  useEffect(() => {
    if (uploadedFile && uploadedFile.url?.includes("image")) {
      const data = {
        recipient: { id: senderId },
        message: {
          attachment: {
            type: "image",
            payload: {
              url: uploadedFile.url,
              is_reusable: true,
            },
          },
        },
      };
      dispatch(instagramsendmessage(data));
    } else if (uploadedFile && uploadedFile.url?.includes("video")) {
      const data = {
        recipient: { id: senderId },
        message: {
          attachment: {
            type: "video",
            payload: {
              url: uploadedFile.url,
              is_reusable: true,
            },
          },
        },
      };
    }
  }, [uploadedFile]);

  useEffect(() => {
    if (sectionRef.current) {
      sectionRef.current.scrollTo(0, sectionRef.current.scrollHeight);
    }
    // setIsSwitchOn(messageNavbar?.autochat)
  }, [messages, currentChatId]);

  let handleCopy = (message) => {
    navigator.clipboard.writeText(message);
  };
  // const ChatSidebar = () => {
  //   document.getElementsByClassName("scroller")[0].classList.add("show");
  // };
  // const ChatSidebarClose = () => {
  //   document.getElementsByClassName("scroller")[0].classList.remove("show");
  // };
  const fetchMessages = async (page) => {
    setIsLoading(true);
    try {
      dispatch(getIgConversationByUser({ currentChatId, page, limit }));
    } catch (error) {
      console.error("Error fetching messages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = (id) => {
    alert(id)
  }
  useEffect(() => {
    // fetchMessages(1); // Load the first page when the component mounts
  }, [conversations]);

  useEffect(() => {
    if (generateMeetingFullfill?.status == 200) {
      setGeneratedLink(generateMeetingFullfill?.meetLink)
    }
  }, [generateMeetingFullfill])

  const handleScroll = () => {
    const container = sectionRef.current;
    if (container.scrollTop === 0) {
      if (!conversationDetails?.data || conversationDetails?.data.length < 20) {
        return;
      }
      if (hasMore && !loading) {
        const currentScrollHeight = container.scrollHeight;
        const nextPage = conversationDetails?.paging?.currentPage + 1;
        fetchMessages(nextPage).then(() => {
          const newScrollHeight = container.scrollHeight;
          container.scrollTop = newScrollHeight - currentScrollHeight;
        });
      }
    }
  };

  const minisidebar = () => {
    const sidebar = document.getElementById("chatsidebar");
    if (sidebar) {
      sidebar.classList.toggle("sidebar-mini2");
    } else {
      console.error("Element with id 'sidebar' not found");
    }
  };

  const handleChatSelect = (item) => {
    setCurrentChatId(item?.id);
    setSenderId(item?.participants?.data[1]?.id);
    setMessageNavbar(item);
    setShowQuickReply(false);
    setNewMessage("");
    setIsSwitchOn(item?.autochat);
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "" || !senderId) return;

    try {
      // const webhookResponse = await igsendmessage(senderId, newMessage);
      // console.log(webhookResponse, "Webhook response");
      // alert("sdsd")

      // const igToken = Cookies.get("igToken");
      const data = {
        recipient: { id: senderId },
        message: { text: newMessage },
      };
      await dispatch(instagramsendmessage(data));

      // const graphResponse = await axios.post(
      //   `https://graph.instagram.com/v18.0/me/messages`,
      //   data,
      //   {
      //     params: { access_token: igToken },
      //   }
      // );

      setNewMessage("");

      // console.log(graphResponse, "Graph API response");
    } catch (error) {
      console.error("Error sending message:", error);
    }
  };
  const onButtonClick = () => {
    inputFile.current.click();
  };

  const handleEmojiClick = (emojiObject) => {
    setNewMessage((prevMessage) => prevMessage + emojiObject.emoji);
  };

  <FsLightbox
    toggler={imageController.toggler}
    sources={[Showimg]}
  // slide={imageController.slide}
  />;

  const handleFileUpload = async (e) => {
    const { files } = e.target;
    if (files && files.length) {
      const filename = files[0].name;

      var parts = filename.split(".");
      const fileType = parts[parts.length - 1];
      const supportedImageTypes = ["jpg", "jpeg", "png", "gif", "bmp"];
      const supportedVideoTypes = ["mp4", "avi", "mov", "wmv"];
      console.log("fileType", fileType); //ex: zip, rar, jpg, svg etc.
      const documentTypes = ["pdf", "doc", "docx", "xls", "xlsx"];
      if (
        supportedImageTypes.includes(fileType) === false ||
        supportedVideoTypes.includes(fileType) !== false
      ) {
        console.log(!supportedImageTypes.includes(fileType));
        alert(
          "Document files are not supported. Please upload an image or video."
        );
        return;
      }

      setImage(files[0]);
      dispatch(uploadFileToCloudinary(files[0]));
      // const documentUrl = await uploadImageToCloudinary(files[0]);
      // console.log(documentUrl, "filedatafiledatafiledata");

      // const igToken = Cookies.get("igToken");
    }
  };
  const handleSwitchChange = async () => {
    let data = {
      currentChatId: currentChatId,
      autochat: !isSwitchOn,
    };
    let response = await dispatch(igautochat(data));

    //  fetchConversations();

    dispatch(fetchIgConversations());
    await setIsSwitchOn(!isSwitchOn); // Toggle the switch state
  };
  const filteredChats = chats?.filter((chat) =>
    chat.participants?.data[1]?.username
      ?.toLowerCase()
      .includes(searchTerm.toLowerCase())
  );
  const onPhoneCall = async () => {
    setGeneratedLink("")
    setShow6(true)
    await dispatch(generateMeeting())
  }

  let handleQuickReplies = (payload) => {
    if (payload) {
      setNewMessage(payload);
      setShowQuickReply(false);
    }
  };
  return (
    <>
      <Tab.Container id="left-tabs-example" defaultActiveKey="first">
        <aside
          className="sidebar sidebar-chat sidebar-base border-end shadow-none"
          data-sidebar="responsive"
          id="chatsidebar"
        >
          <div className="chat-search pt-4 px-4">
            <div className="d-flex align-items-center">
              <h5 className="fw-500">Chats</h5>
            </div>
            <div
              className="sidebar-toggle d-block d-xl-none"
              data-toggle="sidebar"
              data-active="true"
              onClick={minisidebar}
            >
              <i className="icon">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.25 12.2744L19.25 12.2744"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </i>
            </div>
            <div className="chat-searchbar mt-3 pt-1 mb-4">
              <Form.Group className="form-group chat-search-data m-0">
                <input
                  type="text"
                  className="form-control round"
                  id="chat-search"
                  placeholder="Search for messages or users..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
                <i className="material-symbols-outlined">search</i>
              </Form.Group>
            </div>
          </div>

          <div
            className="sidebar-body pt-0 data-scrollbar pb-5 px-4 "
            tabIndex="-1"
            style={{ overflow: "auto", outline: "none" }}
          >
            <div
              className="scroll-content mb-[50px]"
              style={{ transform: "translate3d(0px, 0px, 0px)" }}
            >
              <ul
                className="nav navbar-nav iq-main-menu mb-5 pb-5"
                id="sidebar-menu"
                role="tablist"
              >
                <h6 className="mb-3 pb-1">Recent Chats</h6>
                {filteredChats?.map((chat, index) => {
                  const messageDate = new Date(chat.LastMessageTime);
                  const formattedTime = messageDate.toLocaleTimeString(
                    "en-US",
                    { hour: "2-digit", minute: "2-digit" }
                  );
                  return (
                    <Nav.Item
                      key={index}
                      as="li"
                      className="iq-chat-list mb-[1px]  ps-0"
                      role="presentation"
                    >
                      <Nav.Link
                        className={`d-flex gap-3 rounded-2 zoom-in ${currentChatId === chat?.id ? "active" : ""
                          }`}
                        eventKey="first"
                        onClick={() => handleChatSelect(chat)}
                      >
                        <div className="position-relative">
                          <img
                            src={user1 || "defaultProfilePic.jpg"}
                            alt="User Avatar"
                            className="avatar-48 object-cover rounded-circle"
                            loading="lazy"
                          />
                          {/* <div className="iq-profile-badge bg-success"></div> */}
                        </div>
                        <div className="d-flex align-items-top w-100 iq-userlist-data">
                          <div className="d-flex flex-grow-1 flex-column">
                            <div className="d-flex align-items-center gap-1">
                              <h6 className="mb-0 iq-userlist-name font-size-14 fw-semibold text-ellipsis short-1 flex-grow-1">
                                {chat?.participants?.data[1]?.username ||
                                  "Unknown User"}
                              </h6>
                              <span className="mb-0 font-size-12">
                                {chat.LastMessageTime ? formattedTime : null}
                              </span>
                            </div>
                            <div className="d-flex align-items-center gap-2">
                              <p className="text-ellipsis short-1 flex-grow-1 font-size-14 mb-0">
                                {chat?.LastMessage || ""}
                              </p>
                              {/* <Dropdown className="btn-group dropdown-user">
                              <Dropdown.Toggle
                                as="span"
                                className="bg-transparent dropdown-toggle border-0 text-white"
                                aria-expanded="false"
                              ></Dropdown.Toggle>
                              <Dropdown.Menu
                                as="ul"
                                className="dropdown-menu dropdown-menu-end p-0"
                              >
                                <Dropdown.Item className="font-size-14 text-dark px-2">
                                  <span className="material-symbols-outlined mx-1 font-size-20 align-middle text-body">
                                    share
                                  </span>
                                  Share Contact
                                </Dropdown.Item>
                                <Dropdown.Item className="font-size-14 text-dark px-2">
                                  <span className="material-symbols-outlined mx-1 font-size-20 align-middle text-body">
                                    content_copy
                                  </span>
                                  Copy Contact
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown> */}
                            </div>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="sidebar-footer"></div>
        </aside>
        <main className="main-content">
          <div className="container-fluid content-inner p-0" id="page_layout">
            <Tab.Content id="myTabContent">
              <Tab.Pane //1
                eventKey="first"
                className="card mb-0 fade position-relative"
                id="user-content-101"
                role="tabpanel"
              >
                <div className="chat-nav position-absolute top-0 w-100 z-indexs ">
                  <header className="d-flex justify-content-between align-items-center pt-3 ps-3 pe-3 pb-3">
                    <div className="d-flex align-items-center gap-3">
                      <div className="d-block d-xl-none">
                        <button
                          className="btn btn-sm btn-primary rounded btn-icon"
                          data-toggle="sidebar"
                          data-active="true"
                          onClick={minisidebar}
                        >
                          <span className="btn-inner">
                            <svg
                              className="icon-rtl"
                              width="20px"
                              viewBox="0 0 24 24"
                            >
                              <path
                                fill="currentColor"
                                d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z"
                              ></path>
                            </svg>
                          </span>
                        </button>
                      </div>
                      <div className="avatar chat-user-profile m-0">
                        <img
                          src={user1}
                          alt="avatar"
                          className="avatar-50 object-cover rounded-pill"
                          loading="lazy"
                        />
                        {/* <div className="iq-profile-badge bg-success"></div> */}
                      </div>
                      <div>
                        <h5 className="mb-0">
                          {messageNavbar?.participants?.data[1]?.username}
                        </h5>
                        {/* <small className="text-capitalize fw-500">Online</small> */}
                      </div>
                    </div>

                    <div className="chat-header-icons d-inline-flex ms-auto">
                      <div className="d-flex align-items-center btn btn-primary">
                        <span className="w-100">Autochat</span>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          className="me-2   d-flex align-items-center justify-content-center"
                          checked={isSwitchOn} // Switch state is controlled
                          onChange={handleSwitchChange} // Handle switch toggle
                        />
                      </div>
                      {/* <Link
                        href="#"
                        className="chat-icon-phone  d-flex align-items-center justify-content-center"
                      >
                        <i className="material-symbols-outlined md-18">phone</i>
                      </Link>

                      <Link
                        href="#"
                        className="chat-icon-video  d-flex align-items-center justify-content-center"
                      >
                        <i className="material-symbols-outlined md-18">
                          videocam
                        </i>
                      </Link>
                      <Link
                        href="#"
                        className="chat-icon-delete  d-flex align-items-center justify-content-center"
                      >
                        <i className="material-symbols-outlined md-18">
                          delete
                        </i>
                      </Link> */}
                      <Dropdown
                        className=" d-flex align-items-center justify-content-center"
                        as="span"
                      >
                        <Dropdown.Toggle
                          as="svg"
                          bsPrefix=" "
                          className="icon-20 nav-hide-arrow cursor-pointer pe-0"
                          id="dropdownMenuButton-09"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          role="menu"
                          width="24"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 20.6788C10 21.9595 11.0378 23 12.3113 23C13.5868 23 14.6265 21.9595 14.6265 20.6788C14.6265 19.3981 13.5868 18.3576 12.3113 18.3576C11.0378 18.3576 10 19.3981 10 20.6788ZM10 12.0005C10 13.2812 11.0378 14.3217 12.3113 14.3217C13.5868 14.3217 14.6265 13.2812 14.6265 12.0005C14.6265 10.7198 13.5868 9.67929 12.3113 9.67929C11.0378 9.67929 10 10.7198 10 12.0005ZM12.3113 5.64239C11.0378 5.64239 10 4.60192 10 3.3212C10 2.04047 11.0378 1 12.3113 1C13.5868 1 14.6265 2.04047 14.6265 3.3212C14.6265 4.60192 13.5868 5.64239 12.3113 5.64239Z"
                            fill="currentColor"
                          ></path>
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className="dropdown-menu-right"
                          aria-labelledby="dropdownMenuButton-09"
                        >
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              push_pin
                            </i>
                            Pin to top
                          </Dropdown.Item>
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              delete_outline
                            </i>
                            Delete chat
                          </Dropdown.Item>
                          <Dropdown.Item
                            className=" d-flex align-items-center"
                            href="#"
                          >
                            <i className="material-symbols-outlined md-18 me-1">
                              watch_later
                            </i>
                            Block
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  </header>
                </div>
                <div
                  className="card-body chat-body bg-body All-message"
                  ref={sectionRef}
                  onScroll={handleScroll}
                >
                  {/* Map through each message */}
                  {isLoading && <p>Loading...</p>}
                  {messages?.map((msg, index) => {
                    let messageDate = new Date(msg.created_time);
                    const formattedTime = messageDate.toLocaleTimeString(
                      "en-US",
                      { hour: "2-digit", minute: "2-digit" }
                    );
                    const formattedDate = messageDate.toLocaleDateString(
                      "en-US",
                      { year: "numeric", month: "short", day: "numeric" }
                    );

                    // Check if the date has changed to show the chat-day-title
                    const showDate =
                      index === 0 ||
                      new Date(
                        messages[index - 1]?.created_time
                      ).toDateString() !== messageDate.toDateString();

                    const googleMeetUrlRegex = /(https?:\/\/meet\.google\.com\/[a-zA-Z0-9-]+)/;
                    const googleMeetUrlMatch = msg?.message?.match(googleMeetUrlRegex);
                    const hasGooglemeetUrl = googleMeetUrlMatch ? googleMeetUrlMatch[0] : "";

                    return (
                      <React.Fragment key={msg.id}>
                        {showDate && (
                          <div className="chat-day-title">
                            <span className="main-title">{formattedDate}</span>
                          </div>
                        )}

                        <div
                          className={`iq-message-body ${msg.from.id === instagramAccountId
                            ? "iq-current-user"
                            : "iq-other-user"
                            }`}
                        >
                          <div className="chat-profile text-center">
                            <img
                              src={user1}
                              alt="chat-user"
                              className="avatar-40 object-cover rounded-pill"
                              loading="lazy"
                            />
                            <small className="iq-chating p-0 mb-0 d-block">
                              {formattedTime}
                            </small>
                          </div>

                          <div className="iq-chat-text">
                            <div
                              className={`d-flex align-items-center ${msg.from.id === instagramAccountId
                                ? "justify-content-end"
                                : "justify-content-start"
                                } gap-md-2`}
                            >
                              {msg.from.id === instagramAccountId && (
                                <Dropdown
                                  className="dropdown cursor-pointer more"
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="top"
                                  data-bs-original-title="More"
                                >
                                  <Dropdown.Toggle
                                    className="lh-1"
                                    id="post-option"
                                    data-bs-toggle="dropdown"
                                    as="span"
                                    bsPrefix=" "
                                  >
                                    <span className="material-symbols-outlined text-dark">
                                      more_vert
                                    </span>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu
                                    className="dropdown-menu dropdown-menu-right"
                                    aria-labelledby="post-option"
                                  >

                                    {msg.message && (
                                      <Dropdown.Item
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#post-modal"
                                        onClick={() => handleCopy(msg.message)}
                                      >
                                        <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                          content_copy
                                        </span>
                                        Copy message text
                                      </Dropdown.Item>
                                    )}
                                    {msg && (
                                      <Dropdown.Item
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#post-modal"
                                        onClick={() => handleDelete(msg.id)}
                                      >
                                        <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                          content_copy
                                        </span>
                                        Delete Message
                                      </Dropdown.Item>
                                    )}
                                    <Dropdown.Item
                                      href="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#post-modal"
                                    >
                                      <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                        edit
                                      </span>
                                      Edit
                                    </Dropdown.Item>
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}

                              <div
                                className={
                                  msg.attachments?.data?.[0]?.image_data?.url ||
                                    msg.shares?.data?.[0]?.link ||
                                    msg.attachments?.data?.[0]?.video_data?.url
                                    ? `d-flex align-items-center`
                                    : `iq-chating-content d-flex align-items-center`
                                }
                              >
                                {hasGooglemeetUrl ? (
                                  <div className="d-flex align-items-center">
                                    <a
                                      href={hasGooglemeetUrl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="btn d-flex align-items-center gap-2"
                                    >
                                      <FaVideo size={20} />
                                      <span>Join Google Meet</span>
                                    </a>
                                  </div>
                                ) : msg.attachments?.data?.[0]?.image_data?.url ? (
                                  <img
                                    src={msg.attachments.data[0].image_data.url}
                                    alt="Image attachment"
                                    style={{
                                      maxWidth: "200px",
                                      objectFit: "cover",
                                      borderRadius: "5px",
                                    }}
                                  />
                                ) : msg.shares?.data?.[0]?.link ? (
                                  msg.shares?.data?.[0]?.type ===
                                    "video/mp4" ? (
                                    <iframe
                                      title="video"
                                      className="rounded embed-responsive-item"
                                      src={msg.shares?.data?.[0]?.link}
                                      allowFullScreen
                                      frameBorder="0"
                                      scrolling="no"
                                      allowtransparency="true"
                                      allow="encrypted-media"
                                      width="320"
                                      height="240"
                                    ></iframe>
                                  ) : (
                                    <img
                                      src={msg.shares.data[0].link}
                                      alt="Shared attachment"
                                      style={{
                                        maxWidth: "200px",
                                        objectFit: "cover",
                                        borderRadius: "5px",
                                      }}
                                    />
                                  )
                                ) : msg.attachments?.data?.[0]?.video_data
                                  ?.url ? (
                                  /* If the attachment is a video */
                                  <iframe
                                    title="video"
                                    className="rounded embed-responsive-item"
                                    src={msg.attachments.data[0].video_data.url}
                                    allowFullScreen
                                    frameBorder="0"
                                    scrolling="no"
                                    allowtransparency="true"
                                    allow="encrypted-media"
                                    width="320"
                                    height="240"
                                  ></iframe>
                                ) : (
                                  /* Fallback for message text */
                                  <p className="mr-2 mb-0">{msg.message}</p>
                                )}
                              </div>

                              {msg.from.id !== instagramAccountId && (
                                <>
                                  <Link
                                    href="#"
                                    className="material-symbols-outlined font-size-20 text-dark reply"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-original-title="Reply"
                                  >
                                    reply
                                  </Link>
                                  <Dropdown
                                    className="dropdown cursor-pointer more"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    data-bs-original-title="More"
                                  >
                                    <Dropdown.Toggle
                                      as="span"
                                      bsPrefix=" "
                                      className="lh-1"
                                      id="post-option"
                                      data-bs-toggle="dropdown"
                                    >
                                      <span className="material-symbols-outlined text-dark">
                                        more_vert
                                      </span>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu
                                      className="dropdown-menu dropdown-menu-right"
                                      aria-labelledby="post-option"
                                    >
                                      {msg.message && (
                                        <Dropdown.Item
                                          href="#"
                                          data-bs-toggle="modal"
                                          data-bs-target="#post-modal"
                                          onClick={() =>
                                            handleCopy(msg.message)
                                          }
                                        >
                                          <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                            content_copy
                                          </span>
                                          Copy message text
                                        </Dropdown.Item>
                                      )}
                                      <Dropdown.Item
                                        href="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#post-modal"
                                      >
                                        <span className="material-symbols-outlined align-middle font-size-20 me-1">
                                          edit
                                        </span>
                                        Edit
                                      </Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
                {showEmojiPicker && (
                  <div className="position-absolute left-0 emoji-box">
                    <EmojiPicker onEmojiClick={handleEmojiClick} />
                  </div>
                )}
                {/* {showquickreply && (
                  <div className="position-absolute left-0 emoji-box">
                    <div className="bg-white">
                      {
                        faqs?.map((item,index)=>{
                       return(
                        <p>{item?.title}</p>
                       )
                        })
                      }
                    </div>
                  </div>
                )} */}
                {showquickreply && (
                  <div
                    className="position-absolute emoji-box"
                    style={{
                      left: "0",
                      bottom: "60px",
                      backgroundColor: "white",
                      color: "#fff",
                      width: "100%",
                      maxWidth: "350px",
                      borderRadius: "10px",
                      padding: "20px 10px",
                      boxShadow: "rgb(215 215 215 / 50%) 0px 2",
                      zIndex: 1000,
                    }}
                  >
                    <Row className="mb-2 px-2">
                      <Col>
                        <span
                          className="text-black"
                          style={{ fontSize: "1rem" }}
                        >
                          Quick Replies
                        </span>
                      </Col>
                    </Row>

                    <ListGroup variant="flush">
                      {filteredQuickReplies?.map((item, index) => (
                        <ListGroup.Item
                          key={index}
                          className="bg-transparent text-light border-0 py-2 border-bottom"
                          onClick={() => handleQuickReplies(item.payload)}
                        >
                          <div className="d-flex justify-content-between align-items-center">
                            <div>
                              <span
                                className="text-black"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {item.title}
                              </span>
                              <br />
                              <span
                                className="text-[#a7a7a7]"
                                style={{ fontSize: "0.95rem" }}
                              >
                                {item.payload || "No Title"}
                              </span>
                            </div>
                          </div>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  </div>
                )}
                {humanagent ? (
                  <div className="d-flex justify-content-center px-3 py-3 border-top rounded-0">
                    <Button onClick={() => handleShow()}>
                      send message with HUMAN_AGENT tag
                    </Button>
                  </div>
                ) : (
                  <>
                    <h1>asdasdas</h1>
                  </>
                )}
              </Tab.Pane>
            </Tab.Content>
            <Modal
              show={show}
              onHide={handleClose}
              backdrop="static"
              keyboard={false}
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>
                  <h3>warning !!!</h3>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                You can respond to user inquiries within 7 days after a user
                message. You should only use this for issues that cannot be
                resolved within 24 hours window (e.g., business is closed for
                the weekend, issue requires 24 hours to resolve) Your Facebook
                page could be blocked if you send message for other purpose. Do
                not continue if you are not sure.
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={() => {
                    setHumanagent(false);
                    setShow(false);
                  }}
                >
                  ok
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
        </main>
      </Tab.Container>
    </>
  );
};
export default Chat;
